import { getOverviewHighlights } from "pages/api-clients/graph-search";
import { useMutation } from "react-query";
import { useApplicationContext } from "src/hooks/useApplication";
import { SearchState } from "../types";

export function useEventSummary({ state }: { state: SearchState }) {
  const orgId = useApplicationContext().org_id!;
  const mutation = useMutation({
    mutationFn: async (reporter: string) =>
      getOverviewHighlights({ ...state, reporter }, orgId),
  });
  return {
    isLoading: mutation.isLoading,
    text: mutation.data?.summary || "",
    summarize: mutation.mutate,
    error:
      mutation.isError || mutation.data?.summary === null
        ? "Unable to compile summary"
        : undefined,
  };
}
